module.exports = __webpack_public_path__ + "img/3.69aabfd5.png";